export default {"src":"/_next/static/media/TETHER.070b8100.svg","height":52,"width":60,"blurWidth":0,"blurHeight":0};